import SignatureCanvas from 'react-signature-canvas'
import './SignaturePanel.scss';
import React, { useImperativeHandle, useRef } from 'react';
import { Button } from 'devextreme-react';

type Props = {
  onSubmitDataURL?: (dataURL: string) => void,
  onSubmitBlob?: (blob: Blob) => void
}

export type SignaturePanelHandle = {
  clear: () => void
}
const SignaturePanel: React.ForwardRefRenderFunction<SignaturePanelHandle, Props> = (props, ref) => {
  const sigPad = useRef<SignatureCanvas>(null);

  useImperativeHandle(ref, () => ({
    clear
  }));

  const clear = () => {
    sigPad.current?.clear();
  }

  const submit = () => {
    if (props.onSubmitDataURL){
      var dataUrl = sigPad.current?.getTrimmedCanvas().toDataURL('image/png');
      if (dataUrl)
        props.onSubmitDataURL(dataUrl);
    }
      
    if (props.onSubmitBlob){
      sigPad.current?.getTrimmedCanvas().toBlob(
        (b)=> {
          if (b && props.onSubmitBlob)
            props.onSubmitBlob(b);
        } ,
        'image/png'
      );
    }
  }

  return (
    <React.Fragment>
    <SignatureCanvas ref={sigPad}  penColor='black'
    canvasProps={{width: 500, height: 200, className: 'sigCanvas'}} />
    <div>
        <Button text='Pulisci' onClick={clear} className='buttonClear' />
        <Button text='Conferma' onClick={submit} className='buttonConfirm'/>
      </div>
     </React.Fragment>
  );
}

export default React.forwardRef(SignaturePanel);